import { memo, useMemo } from 'react';
import { cn } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import Stage from './elems/Stage';
import ScrollAnimateContainer from '../ScrollAnimateContainer';

import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { ProcessItemData } from '@Pages/PageExpressDesign/type';

export interface ProccessProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  process: ProcessItemData[];
  onScrollToBlock?: (e: MouseEvent, anchorName: string, tariffId?: string) => void;
}

const Proccess: FC<ProccessProps> = (props) => {
  const { className, process, onScrollToBlock, ...restProps } = props;
  const { isMobile } = useMedias();

  const stages = useMemo(() => {
    return [
      {
        timing: isMobile ? 0.8 : 1.5,
        component: <Stage onScrollToBlock={onScrollToBlock} items={process} />,
      },
    ];
  }, [isMobile, onScrollToBlock, process]);

  return (
    <div {...restProps} className={cn(className)}>
      <ScrollAnimateContainer stages={stages} />
    </div>
  );
};

export default memo(Proccess);
